import React from "react";
import { CodeBlock } from "react-code-blocks";
import hljs from "highlight.js";
import { LANGUAGE_ARRAY } from "../../constants/interview-constants";

interface AiAssessmentCodeAnswerBlockProps {
  userAnswer: string | null;
}
const AiAssessmentCodeAnswerBlock: React.FC<
  AiAssessmentCodeAnswerBlockProps
> = ({ userAnswer }) => {
  const detectLanguage = (code: string) => {
    const result = hljs.highlightAuto(code, LANGUAGE_ARRAY);
    return result.language;
  };

  return (
    <div className="ai-assessment-code-answer-block" >
      <CodeBlock
        text={userAnswer ? userAnswer : "No answer provided"}
        language={userAnswer ? detectLanguage(userAnswer) : "plaintext"}
        showLineNumbers={false}
        theme={"light"}
        customStyle={{
          height: "100%",
          width: "100%",
          overflowY: "auto",
        }}
      />
    </div>
  );
};

export default AiAssessmentCodeAnswerBlock;
